export default "__VITE_ASSET__DOChNyKB__"